import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { useUser } from '@/modules/common/application/context/user';
import { roleFallback } from '@/modules/common/application/route-fallback';
import { UserRole } from '@/modules/common/types';

export const NotFound = () => {
  const { user, company } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center space-y-6 p-8">
        <h2 className="text-3xl font-semibold text-center" data-cy="page-title">
          {t('modules.notFound.title')}
        </h2>
        <p className="text-muted-foreground text-center text-m">
          {t('modules.notFound.description')}
          <br />
        </p>
        <div className="flex gap-4">
          <Button
            onClick={() =>
              navigate(roleFallback(user?.role ?? UserRole.ADMIN, company?.useNewVersion ?? true))
            }
            className="px-6 py-2"
          >
            {t('modules.notFound.linkText')}
          </Button>
          <Button
            onClick={() => (window.location.href = 'mailto:support@mavue.de')}
            variant="outline"
            className="px-6 py-2"
          >
            {t('modules.notFound.contactSupport')}
          </Button>
        </div>
      </div>
    </div>
  );
};
